import { getChargeTotals as getSharedChargeTotals } from '@repo/lib';
import getPriceLabel from '@dashboard/services/translation/getPriceLabel';

export { hasOrderItems, getChargeVariantRows as getVariantRows } from '@repo/lib';

/** The Payment block's totals, in English, from the shared order summary. */
export const getChargeTotals = payment =>
  getSharedChargeTotals(payment, {
    money: amount => getPriceLabel({ amount, currency: payment.currency }),
  });

/** "2 to 5 items" or "2 or more items": the Bulk discount card's min / max quantity in words. */
export const getBulkTier = (discount, noun = 'items') =>
  discount.maxQuantity != null
    ? `${discount.minQuantity} to ${discount.maxQuantity} ${noun}`
    : `${discount.minQuantity} or more ${noun}`;

export const getBulkOff = (discount, currency) =>
  discount.amountOff
    ? `${getPriceLabel({ amount: discount.amountOff, currency })} off each`
    : `${discount.percentOff}% off`;
